import React from "react";
import styled from 'styled-components';
import todopic from '../pictures/todo.jpg';

class Todo extends React.Component {
render(){
const WORKCOVER = styled.div`
    width: 100%;
    height: 100%;
`;

const TITLE = styled.h1`
    margin: 0;
    padding-top: calc(30px + 8vw);
    padding-bottom: 3vh;
    text-align: center;
    color: black;
`;

const BOX = styled.div`
`;

const IMG = styled.img`
    width: 35%;
    height: 100%;
    display: block;
    margin: 0 auto;
    `;

const CONTENT = styled.div`
    padding: 3em;
`;

const TECH = styled.div`
    color: black;
    font-size:calc(10px + 0.4vw)
`;

const BUTTONS = styled.div`
    display: flex;
    justify-content: space-around;
    text-align:center;
    vertical-align: middle;
`;
const BUTTON = styled.a`
    width: calc(40px + 4vw);
    height: calc(20px + 2.5vw);
    line-height: calc(20px + 2.5vw);
    margin: 1em;
    padding: 0.23em 0.5em;
    font-size:calc(10px + 0.4vw)
    font-weight: bold;
    color: white;
    border-style: none;
    border-radius: 3px;
    text-decoration: none;
    background-color: #0F4137;
`;

return(
<div>
<WORKCOVER>
    <TITLE>Todoリスト</TITLE>
    <BOX>
        <IMG src= {todopic} alt=""/>
        <CONTENT>
            <TECH>
            使用技術：<br/>
            HTML/jQuery/JavaScript/React.js/material-UI<br/><br/>
            詳細：<br/>
            Todoと期限を設定できます。<br/>
            Todoを追加すると期限日までの残り日数が表示され、残り日数が少ない順に自動的にTodoが並び替えられます。<br/>
            未記入の欄がある、または期限日が過去に設定されている場合はエラーメッセージが出てTodoの追加ができません。<br/><br/>
            </TECH>
            <BUTTONS>
                <BUTTON href="https://yukiamakawa.github.io/TodoList/" target="_blank">
                    デモ
                </BUTTON>
                <BUTTON href = "https://github.com/YukiAmakawa/TodoList_code" target="_blank">
                    GitHub
                </BUTTON>
            </BUTTONS>
        </CONTENT>
    </BOX>
</WORKCOVER>
</div>
)}}

export default Todo;


// WEBPACK FOOTER //
// ./src/components/Todo.js